export default "__VITE_ASSET__Bw0X7vmW__"